const getters = {
    getProducts: (state) => {
        return _.toArray(state.orderProducts);
    },
    getProductsWithCargoAndOrderOutgoing: (state, getters, rootState, rootGetters) => {
        return _.map(state.orderProducts, product => {
            const cargo = rootGetters['cargo/getCargo'](product.cargoId);
            const order = rootGetters['orders/getOrder'](`${product.orderId}`);
            const receiver = order && order.receiver ? order.receiver : {};
            product.truckNumber = cargo.truckNumber;
            product.trailerNumber = cargo.trailerNumber;
            product.receiverName = receiver.name;
            product.receiver = receiver;
            product.customer = order && order.customer ? order.customer : '';
            let status = '';
            if (product.amount === 0) {
                status = 'done'; // Nothing to load, so we are done
            } else if (!product.amountLoaded) {
                status = 'idle';
            } else if (product.amount !== product.amountLoaded) {
                status = 'busy';
            } else if (product.amount === product.amountLoaded) {
                status = 'done';
            }
            product.state = status;
            return product;
        });
    },
    getProductsFromOrder: (state) => (orderID) => {
        return _.filter(state.orderProducts, (product) => {
            return product.orderId == orderID;
        });
    },
    getProductsFromCargo: (state) => (cargoId) => {
        return _.filter(state.orderProducts, (product) => {
            return product.cargoId.toString() == cargoId.toString();
        });
    },
    // fullProductInfo: (state, getters, rootState, rootGetters) => (product) => {
    //   let pickLocations = _.toArray(rootState.pickLocations.pickLocations)
    //   let locations = _.filter(pickLocations, (pickloc) => {
    //          return product.orderId == pickloc.orderId
    //       }
    //   )
    //    let orderProduct = state.orderProducts[product.id]
    //   orderProduct.locations = locations
    //   return orderProduct
    // },
    getAmountOfAlreadyPickedProducts: (state) => (productNumber) => {
        let counter = 0;
        _.filter(state.orderProducts, (product) => {
            if (product.product.productNumber == productNumber) {
                counter += product.location.amountPicked;
            }
        });
        return counter;
    }

};

export default getters;